import * as employessTypes from "../../types/admin/employessTypes";

export const empListReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_LIST_REQUEST:
      return {
        ...state,
        loadings: true,
      };
    case employessTypes.EMPLOYEES_LIST_SUCCESS:
      return {
        ...state,
        loadings: false,
        employeesList: payload,
        errors: "",
      };
    case employessTypes.EMPLOYEES_LIST_FAIL:
      return {
        ...state,
        loadings: false,
        errors: payload,
        employeesList: [],
      };
    default:
      return state;
  }
};

export const empUserIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_USER_ID_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.EMPLOYEES_USER_ID_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        employeesId: payload,
        error: "",
      };
    case employessTypes.EMPLOYEES_USER_ID_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        employeesId: [],
      };
    default:
      return state;
  }
};

export const empInviteByEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_INVITE_BY_EMAIL_REQUEST:
      return {
        ...state,
        inviteLoading: true,
      };
    case employessTypes.EMPLOYEES_INVITE_BY_EMAIL_SUCCESS:
      return {
        ...state,
        inviteLoading: false,
        inviteInfo: payload,
        inviteError: "",
      };
    case employessTypes.EMPLOYEES_INVITE_BY_EMAIL_FAIL:
      return {
        ...state,
        inviteLoading: false,
        inviteError: payload,
        inviteInfo: [],
      };
    default:
      return state;
  }
};

export const empAllScreenReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_SCREENSHOT_REQUEST:
      return {
        ...state,
        allScreenLoading: true,
      };
    case employessTypes.EMPLOYEES_ALL_SCREENSHOT_SUCCESS:
      return {
        ...state,
        allScreenLoading: false,
        allScreenInfo: payload,
        allScreenError: "",
      };
    case employessTypes.EMPLOYEES_ALL_SCREENSHOT_FAIL:
      return {
        ...state,
        allScreenLoading: false,
        allScreenError: payload,
        allScreenInfo: [],
      };
    default:
      return state;
  }
};

export const empAllReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_REQUEST:
      return {
        ...state,
        allEmpLoading: true,
      };
    case employessTypes.EMPLOYEES_ALL_SUCCESS:
      return {
        ...state,
        allEmpLoading: false,
        allEmpInfo: payload,
        allEmpError: "",
      };
    case employessTypes.EMPLOYEES_ALL_FAIL:
      return {
        ...state,
        allEmpLoading: false,
        allEmpError: payload,
        allEmpInfo: [],
      };
    default:
      return state;
  }
};

export const empAllActivityReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_ACTIVITY_REQUEST:
      return {
        ...state,
        allEmpActLoading: true,
      };
    case employessTypes.EMPLOYEES_ALL_ACTIVITY_SUCCESS:
      return {
        ...state,
        allEmpActLoading: false,
        allEmpActInfo: payload,
        allEmpActError: "",
      };
    case employessTypes.EMPLOYEES_ALL_ACTIVITY_FAIL:
      return {
        ...state,
        allEmpActLoading: false,
        allEmpActError: payload,
        allEmpActInfo: [],
      };
    default:
      return state;
  }
};

export const empAllReportReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_REPORT_REQUEST:
      return {
        ...state,
        allEmpRepLoading: true,
      };
    case employessTypes.EMPLOYEES_ALL_REPORT_SUCCESS:
      return {
        ...state,
        allEmpRepLoading: false,
        allEmpRepInfo: payload,
        allEmpRepError: "",
      };
    case employessTypes.EMPLOYEES_ALL_REPORT_FAIL:
      return {
        ...state,
        allEmpRepLoading: false,
        allEmpRepError: payload,
        allEmpRepInfo: [],
      };
    default:
      return state;
  }
};

export const empAllTimesheetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_TIMESHEET_REQUEST:
      return {
        ...state,
        allEmpSheetLoading: true,
      };
    case employessTypes.EMPLOYEES_ALL_TIMESHEET_SUCCESS:
      return {
        ...state,
        allEmpSheetLoading: false,
        allEmpSheetInfo: payload,
        allEmpSheetError: "",
      };
    case employessTypes.EMPLOYEES_ALL_TIMESHEET_FAIL:
      return {
        ...state,
        allEmpSheetLoading: false,
        allEmpSheetError: payload,
        allEmpSheetInfo: [],
      };
    default:
      return state;
  }
};

export const empAllNewTimesheetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_NEW_TIMESHEET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.EMPLOYEES_ALL_NEW_TIMESHEET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.EMPLOYEES_ALL_NEW_TIMESHEET_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const empAllNewTimesheetStatsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_NEW_TIMESHEET_STATS_REQUEST:
      return {
        ...state,
        info: {},
        loading: true,
      };
    case employessTypes.EMPLOYEES_ALL_NEW_TIMESHEET_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.EMPLOYEES_ALL_NEW_TIMESHEET_STATS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const empSingleNewTimesheetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_SINGLE_NEW_TIMESHEET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.EMPLOYEE_SINGLE_NEW_TIMESHEET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.EMPLOYEE_SINGLE_NEW_TIMESHEET_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const empSingleNewTimesheetStatsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const empAllTimesheetForHrmReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_TIMESHEET_FOR_HRM_REQUEST:
      return {
        ...state,
        allEmpSheetForHrmLoading: true,
      };
    case employessTypes.EMPLOYEES_ALL_TIMESHEET_FOR_HRM_SUCCESS:
      return {
        ...state,
        allEmpSheetForHrmLoading: false,
        allEmpSheetForHrmInfo: payload,
        allEmpSheetForHrmError: "",
      };
    case employessTypes.EMPLOYEES_ALL_TIMESHEET_FOR_HRM_FAIL:
      return {
        ...state,
        allEmpSheetForHrmLoading: false,
        allEmpSheetForHrmError: payload,
        allEmpSheetForHrmInfo: [],
      };
    default:
      return state;
  }
};

export const empOvertimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_OVERTIME_REQUEST:
      return {
        ...state,
        allEmpOvertimeLoading: true,
      };
    case employessTypes.EMPLOYEES_OVERTIME_SUCCESS:
      return {
        ...state,
        allEmpOvertimeLoading: false,
        allEmpOvertimeInfo: payload,
        allEmpOvertimeError: "",
      };
    case employessTypes.EMPLOYEES_OVERTIME_FAIL:
      return {
        ...state,
        allEmpOvertimeLoading: false,
        allEmpOvertimeError: payload,
        allEmpOvertimeInfo: [],
      };
    default:
      return state;
  }
};

export const changeStatusOfTimesheetByRangeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_REQUEST:
      return {
        ...state,
        changeStatusOfTimesheetByRangeLoading: true,
      };
    case employessTypes.CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_SUCCESS:
      return {
        ...state,
        changeStatusOfTimesheetByRangeLoading: false,
        changeStatusOfTimesheetByRangeInfo: payload,
        changeStatusOfTimesheetByRangeError: "",
      };
    case employessTypes.CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_FAIL:
      return {
        ...state,
        changeStatusOfTimesheetByRangeLoading: false,
        changeStatusOfTimesheetByRangeError: payload,
        changeStatusOfTimesheetByRangeInfo: [],
      };
    default:
      return state;
  }
};

export const changeManyEmpStatusOfTimesheetByRangeReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_REQUEST:
      return {
        ...state,
        changeManyEmpStatusOfTimesheetByRangeLoading: true,
      };
    case employessTypes.CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_SUCCESS:
      return {
        ...state,
        changeManyEmpStatusOfTimesheetByRangeLoading: false,
        changeManyEmpStatusOfTimesheetByRangeInfo: payload,
        changeManyEmpStatusOfTimesheetByRangeError: "",
      };
    case employessTypes.CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_FAIL:
      return {
        ...state,
        changeManyEmpStatusOfTimesheetByRangeLoading: false,
        changeManyEmpStatusOfTimesheetByRangeError: payload,
        changeManyEmpStatusOfTimesheetByRangeInfo: [],
      };
    default:
      return state;
  }
};

export const changeStatusOfTimesheetBySingleReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_REQUEST:
      return {
        ...state,
        changeStatusOfTimesheetBySingleLoading: true,
      };
    case employessTypes.CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_SUCCESS:
      return {
        ...state,
        changeStatusOfTimesheetBySingleLoading: false,
        changeStatusOfTimesheetBySingleInfo: payload,
        changeStatusOfTimesheetBySingleError: "",
      };
    case employessTypes.CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_FAIL:
      return {
        ...state,
        changeStatusOfTimesheetBySingleLoading: false,
        changeStatusOfTimesheetBySingleError: payload,
        changeStatusOfTimesheetBySingleInfo: [],
      };
    default:
      return state;
  }
};

export const empAllTeamsReducers = (state = {}, action) => {
  //step 1
  const { type, payload } = action;

  //step 2
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_TEAMS_REQUEST:
      return {
        ...state,
        allEmpTeamsLoading: true,
      };
    case employessTypes.EMPLOYEES_ALL_TEAMS_SUCCESS:
      return {
        ...state,
        allEmpTeamsLoading: false,
        allEmpTeamsInfo: payload,
        allEmpTeamsError: "",
      };
    case employessTypes.EMPLOYEES_ALL_TEAMS_FAIL:
      return {
        ...state,
        allEmpTeamsLoading: false,
        allEmpTeamsError: payload,
        allEmpTeamsInfo: [],
      };
    default:
      return state;
  }
};

export const empAddTimeInProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ADD_TIME_IN_PROJECT_REQUEST:
      return {
        ...state,
        addEmpTimeLoading: true,
      };
    case employessTypes.EMPLOYEES_ADD_TIME_IN_PROJECT_SUCCESS:
      return {
        ...state,
        addEmpTimeLoading: false,
        addEmpTimeInfo: payload,
        addEmpTimeError: "",
      };
    case employessTypes.EMPLOYEES_ADD_TIME_IN_PROJECT_FAIL:
      return {
        ...state,
        addEmpTimeLoading: false,
        addEmpTimeError: payload,
        addEmpTimeInfo: [],
      };
    default:
      return state;
  }
};

export const empEditTimeInProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_EDIT_TIME_IN_PROJECT_REQUEST:
      return {
        ...state,
        editEmpTimeLoading: true,
      };
    case employessTypes.EMPLOYEES_EDIT_TIME_IN_PROJECT_SUCCESS:
      return {
        ...state,
        editEmpTimeLoading: false,
        editEmpTimeInfo: payload,
        editEmpTimeError: "",
      };
    case employessTypes.EMPLOYEES_EDIT_TIME_IN_PROJECT_FAIL:
      return {
        ...state,
        editEmpTimeLoading: false,
        editEmpTimeError: payload,
        editEmpTimeInfo: [],
      };
    default:
      return state;
  }
};

export const empAddInProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_ONE_EMPLOYEE_IN_PROJECT_REQUEST:
      return {
        ...state,
        addProjectLoading: true,
      };
    case employessTypes.ADD_ONE_EMPLOYEE_IN_PROJECT_SUCCESS:
      return {
        ...state,
        addProjectLoading: false,
        addProjectInfo: payload,
        addProjectError: "",
      };
    case employessTypes.ADD_ONE_EMPLOYEE_IN_PROJECT_FAIL:
      return {
        ...state,
        addProjectLoading: false,
        addProjectError: payload,
        addProjectInfo: [],
      };
    default:
      return state;
  }
};

export const empAddInProjectIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_ONE_EMPLOYEE_IN_PROJECT_ID_REQUEST:
      return {
        ...state,
        addEmpProjectIdLoading: true,
      };
    case employessTypes.ADD_ONE_EMPLOYEE_IN_PROJECT_ID_SUCCESS:
      return {
        ...state,
        addEmpProjectIdLoading: false,
        addEmpProjectIdInfo: payload,
        addEmpProjectIdError: "",
      };
    case employessTypes.ADD_ONE_EMPLOYEE_IN_PROJECT_ID_FAIL:
      return {
        ...state,
        addEmpProjectIdLoading: false,
        addEmpProjectIdError: payload,
        addEmpProjectIdInfo: [],
      };
    default:
      return state;
  }
};

export const empTimeProDasboardDateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_TIMEPRO_DATE_REQUEST:
      return {
        ...state,
        empTimeProDashDateLoading: true,
      };
    case employessTypes.EMPLOYEE_TIMEPRO_DATE_SUCCESS:
      return {
        ...state,
        empTimeProDashDateLoading: false,
        empTimeProDashDateInfo: payload,
        empTimeProDashDateError: "",
      };
    case employessTypes.EMPLOYEE_TIMEPRO_DATE_FAIL:
      return {
        ...state,
        empTimeProDashDateLoading: false,
        empTimeProDashDateError: payload,
        empTimeProDashDateInfo: [],
      };
    default:
      return state;
  }
};

export const empTimeProDasboardWeekReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_TIMEPRO_WEEK_REQUEST:
      return {
        ...state,
        empTimeProDashWeekLoading: true,
      };
    case employessTypes.EMPLOYEE_TIMEPRO_WEEK_SUCCESS:
      return {
        ...state,
        empTimeProDashWeekLoading: false,
        empTimeProDashWeekInfo: payload,
        empTimeProDashWeekError: "",
      };
    case employessTypes.EMPLOYEE_TIMEPRO_WEEK_FAIL:
      return {
        ...state,
        empTimeProDashWeekLoading: false,
        empTimeProDashWeekError: payload,
        empTimeProDashWeekInfo: [],
      };
    default:
      return state;
  }
};

export const empTimeProDasboardSevenReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_TIMEPRO_SEVEN_REQUEST:
      return {
        ...state,
        empTimeProDashSevenLoading: true,
      };
    case employessTypes.EMPLOYEE_TIMEPRO_SEVEN_SUCCESS:
      return {
        ...state,
        empTimeProDashSevenLoading: false,
        empTimeProDashSevenInfo: payload,
        empTimeProDashSevenError: "",
      };
    case employessTypes.EMPLOYEE_TIMEPRO_SEVEN_FAIL:
      return {
        ...state,
        empTimeProDashSevenLoading: false,
        empTimeProDashSevenError: payload,
        empTimeProDashSevenInfo: [],
      };
    default:
      return state;
  }
};

export const empAllCheckinReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_ALL_CHECKIN_REQUEST:
      return {
        ...state,
        empAllCheckLoading: true,
      };
    case employessTypes.EMPLOYEES_ALL_CHECKIN_SUCCESS:
      return {
        ...state,
        empAllCheckLoading: false,
        empAllCheckInfo: payload,
        empAllCheckError: "",
      };
    case employessTypes.EMPLOYEES_ALL_CHECKIN_FAIL:
      return {
        ...state,
        empAllCheckLoading: false,
        empAllCheckError: payload,
        empAllCheckInfo: [],
      };
    default:
      return state;
  }
};

export const empBlockFromCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_BLOCK_FROM_COMPANY_REQUEST:
      return {
        ...state,
        blockEmpLoading: true,
      };
    case employessTypes.EMPLOYEES_BLOCK_FROM_COMPANY_SUCCESS:
      return {
        ...state,
        blockEmpLoading: false,
        blockEmpInfo: payload,
        blockEmpError: "",
      };
    case employessTypes.EMPLOYEES_BLOCK_FROM_COMPANY_FAIL:
      return {
        ...state,
        blockEmpLoading: false,
        blockEmpError: payload,
        blockEmpInfo: [],
      };
    default:
      return state;
  }
};

export const empDeleteFromCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_DELETE_FROM_COMPANY_REQUEST:
      return {
        ...state,
        deleteEmpLoading: true,
      };
    case employessTypes.EMPLOYEES_DELETE_FROM_COMPANY_SUCCESS:
      return {
        ...state,
        deleteEmpLoading: false,
        deleteEmpInfo: payload,
        deleteEmpError: "",
      };
    case employessTypes.EMPLOYEES_DELETE_FROM_COMPANY_FAIL:
      return {
        ...state,
        deleteEmpLoading: false,
        deleteEmpError: payload,
        deleteEmpInfo: [],
      };
    default:
      return state;
  }
};

export const empBlockFromDepartmentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_BLOCK_FROM_DEPARTMENT_REQUEST:
      return {
        ...state,
        blockEmpDepartLoading: true,
      };
    case employessTypes.EMPLOYEES_BLOCK_FROM_DEPARTMENT_SUCCESS:
      return {
        ...state,
        blockEmpDepartLoading: false,
        blockEmpDepartInfo: payload,
        blockEmpDepartError: "",
      };
    case employessTypes.EMPLOYEES_BLOCK_FROM_DEPARTMENT_FAIL:
      return {
        ...state,
        blockEmpDepartLoading: false,
        blockEmpDepartError: payload,
        blockEmpDepartInfo: [],
      };
    default:
      return state;
  }
};

export const empUpdatDetailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEE_DETAILS_REQUEST:
      return {
        ...state,
        updateEmpDetailLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        updateEmpDetailLoading: false,
        updateEmpDetailInfo: payload,
        updateEmpDetailError: "",
      };
    case employessTypes.UPDATE_EMPLOYEE_DETAILS_FAIL:
      return {
        ...state,
        updateEmpDetailLoading: false,
        updateEmpDetailError: payload,
        updateEmpDetailInfo: [],
      };
    default:
      return state;
  }
};

export const empDeleteProjectTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.DELETE_PROJECT_TIME_OF_EMPLOYEE_REQUEST:
      return {
        ...state,
        delEmpProTimeLoading: true,
      };
    case employessTypes.DELETE_PROJECT_TIME_OF_EMPLOYEE_SUCCESS:
      return {
        ...state,
        delEmpProTimeLoading: false,
        delEmpProTimeInfo: payload,
        delEmpProTimeError: "",
      };
    case employessTypes.DELETE_PROJECT_TIME_OF_EMPLOYEE_FAIL:
      return {
        ...state,
        delEmpProTimeLoading: false,
        delEmpProTimeError: payload,
        delEmpProTimeInfo: [],
      };
    default:
      return state;
  }
};

export const sendEmpResetPassEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.SEND_OTP_EMAIL_BY_ADMIN_REQUEST:
      return {
        ...state,
        sendResetPassEmpLoading: true,
      };
    case employessTypes.SEND_OTP_EMAIL_BY_ADMIN_SUCCESS:
      return {
        ...state,
        sendResetPassEmpLoading: false,
        sendResetPassEmpInfo: payload,
        sendResetPassEmpError: "",
      };
    case employessTypes.SEND_OTP_EMAIL_BY_ADMIN_FAIL:
      return {
        ...state,
        sendResetPassEmpLoading: false,
        sendResetPassEmpError: payload,
        sendResetPassEmpInfo: [],
      };
    default:
      return state;
  }
};

export const updateEmpScreenShotReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_REASON_IN_EMP_SCREENSHOT_REQUEST:
      return {
        ...state,
        updateScreenEmpLoading: true,
      };
    case employessTypes.UPDATE_REASON_IN_EMP_SCREENSHOT_SUCCESS:
      return {
        ...state,
        updateScreenEmpLoading: false,
        updateScreenEmpInfo: payload,
        updateScreenEmpError: "",
      };
    case employessTypes.UPDATE_REASON_IN_EMP_SCREENSHOT_FAIL:
      return {
        ...state,
        updateScreenEmpLoading: false,
        updateScreenEmpError: payload,
        updateScreenEmpInfo: [],
      };
    default:
      return state;
  }
};

export const deleteEmpScreenShotReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.DELETE_SCREENSHOT_REQUEST:
      return {
        ...state,
        deleteScreenEmpLoading: true,
      };
    case employessTypes.DELETE_SCREENSHOT_SUCCESS:
      return {
        ...state,
        deleteScreenEmpLoading: false,
        deleteScreenEmpInfo: payload,
        deleteScreenEmpError: "",
      };
    case employessTypes.DELETE_SCREENSHOT_FAIL:
      return {
        ...state,
        deleteScreenEmpLoading: false,
        deleteScreenEmpError: payload,
        deleteScreenEmpInfo: [],
      };
    default:
      return state;
  }
};

export const addUserInDepartmentWithProReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_REQUEST:
      return {
        ...state,
        addUserDepartWProLoading: true,
      };
    case employessTypes.ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_SUCCESS:
      return {
        ...state,
        addUserDepartWProLoading: false,
        addUserDepartWProInfo: payload,
        addUserDepartWProError: "",
      };
    case employessTypes.ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_FAIL:
      return {
        ...state,
        addUserDepartWProLoading: false,
        addUserDepartWProError: payload,
        addUserDepartWProInfo: {},
      };
    default:
      return state;
  }
};

export const empUpdatTypeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEE_TYPE_REQUEST:
      return {
        ...state,
        updateEmpTypeLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEE_TYPE_SUCCESS:
      return {
        ...state,
        updateEmpTypeLoading: false,
        updateEmpTypeInfo: payload,
        updateEmpTypeError: "",
      };
    case employessTypes.UPDATE_EMPLOYEE_TYPE_FAIL:
      return {
        ...state,
        updateEmpTypeLoading: false,
        updateEmpTypeError: payload,
        updateEmpTypeInfo: [],
      };
    default:
      return state;
  }
};

//get checkIn report by range
export const getEmpCheckinByRangeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_CHECKIN_BY_RANGE_REQUEST:
      return {
        ...state,
        getEmpCheckInLoading: true,
      };
    case employessTypes.EMPLOYEES_CHECKIN_BY_RANGE_SUCCESS:
      return {
        ...state,
        getEmpCheckInLoading: false,
        getEmpCheckInInfo: payload,
        getEmpCheckInError: "",
      };
    case employessTypes.EMPLOYEES_CHECKIN_BY_RANGE_FAIL:
      return {
        ...state,
        getEmpCheckInLoading: false,
        getEmpCheckInError: payload,
        getEmpCheckInInfo: [],
      };
    default:
      return state;
  }
};

//get total time report for payroll by range
export const getEmpTotalTimeByRangeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_TOTAL_TIME_BY_RANGE_REQUEST:
      return {
        ...state,
        getEmpTotalTimeLoading: true,
      };
    case employessTypes.EMPLOYEES_TOTAL_TIME_BY_RANGE_SUCCESS:
      return {
        ...state,
        getEmpTotalTimeLoading: false,
        getEmpTotalTimeInfo: payload,
        getEmpTotalTimeError: "",
      };
    case employessTypes.EMPLOYEES_TOTAL_TIME_BY_RANGE_FAIL:
      return {
        ...state,
        getEmpTotalTimeLoading: false,
        getEmpTotalTimeError: payload,
        getEmpTotalTimeInfo: [],
      };
    default:
      return state;
  }
};

//Post Employee Extra Info
export const addEmployeeExtraInfoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_EXTRA_INFO_REQUEST:
      return {
        ...state,
        addEmpExtraLoading: true,
      };
    case employessTypes.EMPLOYEES_EXTRA_INFO_SUCCESS:
      return {
        ...state,
        addEmpExtraLoading: false,
        addEmpExtraInfo: payload,
        addEmpExtraError: "",
      };
    case employessTypes.EMPLOYEES_EXTRA_INFO_FAIL:
      return {
        ...state,
        addEmpExtraLoading: false,
        addEmpExtraError: payload,
        addEmpExtraInfo: [],
      };
    default:
      return state;
  }
};

//Post Employee Extra Social
export const addEmployeeExtraSocialReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_EXTRA_SOCIAL_REQUEST:
      return {
        ...state,
        addEmpExtraSocialLoading: true,
      };
    case employessTypes.EMPLOYEES_EXTRA_SOCIAL_SUCCESS:
      return {
        ...state,
        addEmpExtraSocialLoading: false,
        addEmpExtraSocialInfo: payload,
        addEmpExtraSocialError: "",
      };
    case employessTypes.EMPLOYEES_EXTRA_SOCIAL_FAIL:
      return {
        ...state,
        addEmpExtraSocialLoading: false,
        addEmpExtraSocialError: payload,
        addEmpExtraSocialInfo: [],
      };
    default:
      return state;
  }
};

//Post Employee Extra Work
export const addEmployeeExtraWorkReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEES_EXTRA_WORK_REQUEST:
      return {
        ...state,
        addEmpExtraWorkLoading: true,
      };
    case employessTypes.EMPLOYEES_EXTRA_WORK_SUCCESS:
      return {
        ...state,
        addEmpExtraWorkLoading: false,
        addEmpExtraWorkInfo: payload,
        addEmpExtraWorkError: "",
      };
    case employessTypes.EMPLOYEES_EXTRA_WORK_FAIL:
      return {
        ...state,
        addEmpExtraWorkLoading: false,
        addEmpExtraWorkError: payload,
        addEmpExtraWorkInfo: [],
      };
    default:
      return state;
  }
};

//Get Employee Extra Info
export const getEmployeeExtraInfoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_EMPLOYEES_EXTRA_INFO_REQUEST:
      return {
        ...state,
        getEmpExtraLoading: true,
      };
    case employessTypes.GET_EMPLOYEES_EXTRA_INFO_SUCCESS:
      return {
        ...state,
        getEmpExtraLoading: false,
        getEmpExtraInfo: payload,
        getEmpExtraError: "",
      };
    case employessTypes.GET_EMPLOYEES_EXTRA_INFO_FAIL:
      return {
        ...state,
        getEmpExtraLoading: false,
        getEmpExtraError: payload,
        getEmpExtraInfo: [],
      };
    default:
      return state;
  }
};

//Add Profile Image Of Employees
export const addEmployeeProfileImageReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_EMPLOYEES_PROFILE_IMAGE_REQUEST:
      return {
        ...state,
        addEmpProImageLoading: true,
      };
    case employessTypes.ADD_EMPLOYEES_PROFILE_IMAGE_SUCCESS:
      return {
        ...state,
        addEmpProImageLoading: false,
        addEmpProImageInfo: payload,
        addEmpProImageError: "",
      };
    case employessTypes.ADD_EMPLOYEES_PROFILE_IMAGE_FAIL:
      return {
        ...state,
        addEmpProImageLoading: false,
        addEmpProImageError: payload,
        addEmpProImageInfo: [],
      };
    default:
      return state;
  }
};

//Add Extra Personal Info Of Employees
export const addEmployeeExtraPersonalInfoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_REQUEST:
      return {
        ...state,
        addEmpExtraPersonalLoading: true,
      };
    case employessTypes.ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        addEmpExtraPersonalLoading: false,
        addEmpExtraPersonalInfo: payload,
        addEmpExtraPersonalError: "",
      };
    case employessTypes.ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_FAIL:
      return {
        ...state,
        addEmpExtraPersonalLoading: false,
        addEmpExtraPersonalError: payload,
        addEmpExtraPersonalInfo: [],
      };
    default:
      return state;
  }
};

//Add Employee's Asset
export const addEmployeesAssetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_EMPLOYEES_ASSET_REQUEST:
      return {
        ...state,
        addEmpAssetLoading: true,
      };
    case employessTypes.ADD_EMPLOYEES_ASSET_SUCCESS:
      return {
        ...state,
        addEmpAssetLoading: false,
        addEmpAssetInfo: payload,
        addEmpAssetError: "",
      };
    case employessTypes.ADD_EMPLOYEES_ASSET_FAIL:
      return {
        ...state,
        addEmpAssetLoading: false,
        addEmpAssetError: payload,
        addEmpAssetInfo: [],
      };
    default:
      return state;
  }
};

//Update Employee's Asset
export const updateEmployeesAssetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_ASSET_REQUEST:
      return {
        ...state,
        updateEmpAssetLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_ASSET_SUCCESS:
      return {
        ...state,
        updateEmpAssetLoading: false,
        updateEmpAssetInfo: payload,
        updateEmpAssetError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_ASSET_FAIL:
      return {
        ...state,
        updateEmpAssetLoading: false,
        updateEmpAssetError: payload,
        updateEmpAssetInfo: [],
      };
    default:
      return state;
  }
};

//Update Employee's Archived Asset
export const updateEmployeesArchivedAssetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_ARCHIVED_ASSET_REQUEST:
      return {
        ...state,
        archivedEmpAssetLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_ARCHIVED_ASSET_SUCCESS:
      return {
        ...state,
        archivedEmpAssetLoading: false,
        archivedEmpAssetInfo: payload,
        archivedEmpAssetError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_ARCHIVED_ASSET_FAIL:
      return {
        ...state,
        archivedEmpAssetLoading: false,
        archivedEmpAssetError: payload,
        archivedEmpAssetInfo: [],
      };
    default:
      return state;
  }
};

//Update Employee's front document
export const updateEmpFrontDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_FRONT_DOC_REQUEST:
      return {
        ...state,
        addEmpFrontDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_FRONT_DOC_SUCCESS:
      return {
        ...state,
        addEmpFrontDocLoading: false,
        addEmpFrontDocInfo: payload,
        addEmpFrontDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_FRONT_DOC_FAIL:
      return {
        ...state,
        addEmpFrontDocLoading: false,
        addEmpFrontDocError: payload,
        addEmpFrontDocInfo: [],
      };
    default:
      return state;
  }
};

//Update Employee's back document
export const updateEmpBackDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_BACK_DOC_REQUEST:
      return {
        ...state,
        addEmpBackDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_BACK_DOC_SUCCESS:
      return {
        ...state,
        addEmpBackDocLoading: false,
        addEmpBackDocInfo: payload,
        addEmpBackDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_BACK_DOC_FAIL:
      return {
        ...state,
        addEmpBackDocLoading: false,
        addEmpBackDocError: payload,
        addEmpBackDocInfo: [],
      };
    default:
      return state;
  }
};

//Update Employee's other document
export const updateEmpOtherDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_OTHER_DOC_REQUEST:
      return {
        ...state,
        addEmpOtherDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_OTHER_DOC_SUCCESS:
      return {
        ...state,
        addEmpOtherDocLoading: false,
        addEmpOtherDocInfo: payload,
        addEmpOtherDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_OTHER_DOC_FAIL:
      return {
        ...state,
        addEmpOtherDocLoading: false,
        addEmpOtherDocError: payload,
        addEmpOtherDocInfo: [],
      };
    default:
      return state;
  }
};

//Update Employee's passport photos
export const updateEmpPassPortReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_PASSPORT_PHOTO_REQUEST:
      return {
        ...state,
        addEmpPassPortPhotoLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_PASSPORT_PHOTO_SUCCESS:
      return {
        ...state,
        addEmpPassPortPhotoLoading: false,
        addEmpPassPortPhotoInfo: payload,
        addEmpPassPortPhotoError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_PASSPORT_PHOTO_FAIL:
      return {
        ...state,
        addEmpPassPortPhotoLoading: false,
        addEmpPassPortPhotoError: payload,
        addEmpPassPortPhotoInfo: [],
      };
    default:
      return state;
  }
};

//Archived Employee's other document
export const archivedEmpOtherDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ARCHIVED_EMPLOYEES_OTHER_DOC_REQUEST:
      return {
        ...state,
        archivedEmpDocLoading: true,
      };
    case employessTypes.ARCHIVED_EMPLOYEES_OTHER_DOC_SUCCESS:
      return {
        ...state,
        archivedEmpDocLoading: false,
        archivedEmpDocInfo: payload,
        archivedEmpDocError: "",
      };
    case employessTypes.ARCHIVED_EMPLOYEES_OTHER_DOC_FAIL:
      return {
        ...state,
        archivedEmpDocLoading: false,
        archivedEmpDocError: payload,
        archivedEmpDocInfo: [],
      };
    default:
      return state;
  }
};

//Add Employee's Expense
export const addEmployeesExpenseReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_EMPLOYEES_EXPENSE_REQUEST:
      return {
        ...state,
        addEmpExpenseLoading: true,
      };
    case employessTypes.ADD_EMPLOYEES_EXPENSE_SUCCESS:
      return {
        ...state,
        addEmpExpenseLoading: false,
        addEmpExpenseInfo: payload,
        addEmpExpenseError: "",
      };
    case employessTypes.ADD_EMPLOYEES_EXPENSE_FAIL:
      return {
        ...state,
        addEmpExpenseLoading: false,
        addEmpExpenseError: payload,
        addEmpExpenseInfo: [],
      };
    default:
      return state;
  }
};

//Update Employee's Expense
export const updateEmployeesExpenseReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_EXPENSE_REQUEST:
      return {
        ...state,
        updateEmpExpenseLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_EXPENSE_SUCCESS:
      return {
        ...state,
        updateEmpExpenseLoading: false,
        updateEmpExpenseInfo: payload,
        updateEmpExpenseError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_EXPENSE_FAIL:
      return {
        ...state,
        updateEmpExpenseLoading: false,
        updateEmpExpenseError: payload,
        updateEmpExpenseInfo: [],
      };
    default:
      return state;
  }
};

//Update Employee's Archived Expense
export const updateEmployeesArchivedExpenseReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_REQUEST:
      return {
        ...state,
        archivedEmpExpenseLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_SUCCESS:
      return {
        ...state,
        archivedEmpExpenseLoading: false,
        archivedEmpExpenseInfo: payload,
        archivedEmpExpenseError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_FAIL:
      return {
        ...state,
        archivedEmpExpenseLoading: false,
        archivedEmpExpenseError: payload,
        archivedEmpExpenseInfo: [],
      };
    default:
      return state;
  }
};

export const getAllCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_GET_ALL_COMPANY_LIST_REQUEST:
      return {
        ...state,
        getAllCompaniesLoading: true,
      };
    case employessTypes.ADMIN_GET_ALL_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        getAllCompaniesLoading: false,
        getAllCompaniesInfo: payload,
        getAllCompaniesError: "",
      };
    case employessTypes.ADMIN_GET_ALL_COMPANY_LIST_FAIL:
      return {
        ...state,
        getAllCompaniesLoading: false,
        getAllCompaniesError: payload,
        getAllCompaniesInfo: {},
      };
    default:
      return state;
  }
};

export const openAnotherCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_OPEN_ANOTHER_COMPANY_LIST_REQUEST:
      return {
        ...state,
        openAnotherCompanyLoading: true,
      };
    case employessTypes.ADMIN_OPEN_ANOTHER_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        openAnotherCompanyLoading: false,
        openAnotherCompanyInfo: payload,
        openAnotherCompanyError: "",
      };
    case employessTypes.ADMIN_OPEN_ANOTHER_COMPANY_LIST_FAIL:
      return {
        ...state,
        openAnotherCompanyLoading: false,
        openAnotherCompanyError: payload,
        openAnotherCompanyInfo: {},
      };
    default:
      return state;
  }
};

export const adminArchiveCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_ARCHIVE_COMPANY_LIST_REQUEST:
      return {
        ...state,
        archiveCompanyLoading: true,
      };
    case employessTypes.ADMIN_ARCHIVE_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        archiveCompanyLoading: false,
        archiveCompanyInfo: payload,
        archiveCompanyError: "",
      };
    case employessTypes.ADMIN_ARCHIVE_COMPANY_LIST_FAIL:
      return {
        ...state,
        archiveCompanyLoading: false,
        archiveCompanyError: payload,
        archiveCompanyInfo: {},
      };
    default:
      return state;
  }
};

export const adminDynamicDocumentsImportCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_DYNAMIC_DOCUMENTS_IMPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.ADMIN_DYNAMIC_DOCUMENTS_IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.ADMIN_DYNAMIC_DOCUMENTS_IMPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};
export const adminAddUserImportCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_ADD_USER_IMPORT_REQUEST:
      return {
        ...state,
        addUserImportCompanyLoading: true,
      };
    case employessTypes.ADMIN_ADD_USER_IMPORT_SUCCESS:
      return {
        ...state,
        addUserImportCompanyLoading: false,
        addUserImportCompanyInfo: payload,
        addUserImportCompanyError: "",
      };
    case employessTypes.ADMIN_ADD_USER_IMPORT_FAIL:
      return {
        ...state,
        addUserImportCompanyLoading: false,
        addUserImportCompanyError: payload,
        addUserImportCompanyInfo: {},
      };
    default:
      return state;
  }
};

export const adminAddUserImportCompanyUploadReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_ADD_USER_IMPORT_UPLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.ADMIN_ADD_USER_IMPORT_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        addUserImportCompanyInfo: payload,
        addUserImportCompanyError: "",
      };
    case employessTypes.ADMIN_ADD_USER_IMPORT_UPLOAD_FAIL:
      return {
        ...state,
        loading: false,
        addUserImportCompanyError: payload,
        addUserImportCompanyInfo: {},
      };
    default:
      return state;
  }
};

export const adminCheckUserImportCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_CHECK_USER_IMPORT_REQUEST:
      return {
        ...state,
        checkUserImportCompanyLoading: true,
      };
    case employessTypes.ADMIN_CHECK_USER_IMPORT_SUCCESS:
      return {
        ...state,
        checkUserImportCompanyLoading: false,
        checkUserImportCompanyInfo: payload,
        checkUserImportCompanyError: "",
      };
    case employessTypes.ADMIN_CHECK_USER_IMPORT_FAIL:
      return {
        ...state,
        checkUserImportCompanyLoading: false,
        checkUserImportCompanyError: payload,
        checkUserImportCompanyInfo: {},
      };
    default:
      return state;
  }
};

export const addShiftManagementUserIdCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_USER_ID_SHIFT_REQUEST:
      return {
        ...state,
        addShiftManagUserIdLoading: true,
      };
    case employessTypes.ADD_USER_ID_SHIFT_SUCCESS:
      return {
        ...state,
        addShiftManagUserIdLoading: false,
        addShiftManagUserIdInfo: payload,
        addShiftManagUserIdError: "",
      };
    case employessTypes.ADD_USER_ID_SHIFT_FAIL:
      return {
        ...state,
        addShiftManagUserIdLoading: false,
        addShiftManagUserIdError: payload,
        addShiftManagUserIdInfo: {},
      };
    default:
      return state;
  }
};

export const updateStatusSingleShiftReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_STATUS_OF_SHIFT_REQUEST:
      return {
        ...state,
        updateStatusSingleShiftLoading: true,
      };
    case employessTypes.UPDATE_STATUS_OF_SHIFT_SUCCESS:
      return {
        ...state,
        updateStatusSingleShiftLoading: false,
        updateStatusSingleShiftInfo: payload,
        updateStatusSingleShiftError: "",
      };
    case employessTypes.UPDATE_STATUS_OF_SHIFT_FAIL:
      return {
        ...state,
        updateStatusSingleShiftLoading: false,
        updateStatusSingleShiftError: payload,
        updateStatusSingleShiftInfo: {},
      };
    default:
      return state;
  }
};

export const updateStatusTemplateShiftReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.CHANGE_STATUS_OF_TEMPLATE_SHIFT_REQUEST:
      return {
        ...state,
        updateStatusTemplateShiftLoading: true,
      };
    case employessTypes.CHANGE_STATUS_OF_TEMPLATE_SHIFT_SUCCESS:
      return {
        ...state,
        updateStatusTemplateShiftLoading: false,
        updateStatusTemplateShiftInfo: payload,
        updateStatusTemplateShiftError: "",
      };
    case employessTypes.CHANGE_STATUS_OF_TEMPLATE_SHIFT_FAIL:
      return {
        ...state,
        updateStatusTemplateShiftLoading: false,
        updateStatusTemplateShiftError: payload,
        updateStatusTemplateShiftInfo: {},
      };
    default:
      return state;
  }
};

export const updateWeekTemplateShiftReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_WEEK_TEMPLATE_SHIFT_REQUEST:
      return {
        ...state,
        updateWeekTemplateShiftLoading: true,
      };
    case employessTypes.ADD_WEEK_TEMPLATE_SHIFT_SUCCESS:
      return {
        ...state,
        updateWeekTemplateShiftLoading: false,
        updateWeekTemplateShiftInfo: payload,
        updateWeekTemplateShiftError: "",
      };
    case employessTypes.ADD_WEEK_TEMPLATE_SHIFT_FAIL:
      return {
        ...state,
        updateWeekTemplateShiftLoading: false,
        updateWeekTemplateShiftError: payload,
        updateWeekTemplateShiftInfo: {},
      };
    default:
      return state;
  }
};

export const addManyInShiftWeekTemplateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_MANY_EMPLOYEES_WEEK_SHIFT_REQUEST:
      return {
        ...state,
        addManyInShiftWeekTemplateLoading: true,
      };
    case employessTypes.ADD_MANY_EMPLOYEES_WEEK_SHIFT_SUCCESS:
      return {
        ...state,
        addManyInShiftWeekTemplateLoading: false,
        addManyInShiftWeekTemplateInfo: payload,
        addManyInShiftWeekTemplateError: "",
      };
    case employessTypes.ADD_MANY_EMPLOYEES_WEEK_SHIFT_FAIL:
      return {
        ...state,
        addManyInShiftWeekTemplateLoading: false,
        addManyInShiftWeekTemplateError: payload,
        addManyInShiftWeekTemplateInfo: {},
      };
    default:
      return state;
  }
};

export const deleteManyInShiftWeekTemplateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.DELETE_MANY_EMPLOYEES_WEEK_SHIFT_REQUEST:
      return {
        ...state,
        deleteManyInShiftWeekTemplateLoading: true,
      };
    case employessTypes.DELETE_MANY_EMPLOYEES_WEEK_SHIFT_SUCCESS:
      return {
        ...state,
        deleteManyInShiftWeekTemplateLoading: false,
        deleteManyInShiftWeekTemplateInfo: payload,
        deleteManyInShiftWeekTemplateError: "",
      };
    case employessTypes.DELETE_MANY_EMPLOYEES_WEEK_SHIFT_FAIL:
      return {
        ...state,
        deleteManyInShiftWeekTemplateLoading: false,
        deleteManyInShiftWeekTemplateError: payload,
        deleteManyInShiftWeekTemplateInfo: {},
      };
    default:
      return state;
  }
};

export const addApplicationDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_APPLICATION_DOC_REQUEST:
      return {
        ...state,
        addAppDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_APPLICATION_DOC_SUCCESS:
      return {
        ...state,
        addAppDocLoading: false,
        addAppDocInfo: payload,
        addAppDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_APPLICATION_DOC_FAIL:
      return {
        ...state,
        addAppDocLoading: false,
        addAppDocError: payload,
        addAppDocInfo: {},
      };
    default:
      return state;
  }
};

export const addVisaDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_VISA_DOC_REQUEST:
      return {
        ...state,
        addVisaDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_VISA_DOC_SUCCESS:
      return {
        ...state,
        addVisaDocLoading: false,
        addVisaDocInfo: payload,
        addVisaDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_VISA_DOC_FAIL:
      return {
        ...state,
        addVisaDocLoading: false,
        addVisaDocError: payload,
        addVisaDocInfo: {},
      };
    default:
      return state;
  }
};

export const addPassportDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_PASSPORT_DOC_REQUEST:
      return {
        ...state,
        addPassportDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_PASSPORT_DOC_SUCCESS:
      return {
        ...state,
        addPassportDocLoading: false,
        addPassportDocInfo: payload,
        addPassportDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_PASSPORT_DOC_FAIL:
      return {
        ...state,
        addPassportDocLoading: false,
        addPassportDocError: payload,
        addPassportDocInfo: {},
      };
    default:
      return state;
  }
};

export const addShiftManagementCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_SHIFT_REQUEST:
      return {
        ...state,
        addShiftManagLoading: true,
      };
    case employessTypes.ADD_SHIFT_SUCCESS:
      return {
        ...state,
        addShiftManagLoading: false,
        addShiftManagInfo: payload,
        addShiftManagError: "",
      };
    case employessTypes.ADD_SHIFT_FAIL:
      return {
        ...state,
        addShiftManagLoading: false,
        addShiftManagError: payload,
        addShiftManagInfo: {},
      };
    default:
      return state;
  }
};

export const getShiftManagementCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_SHIFT_REQUEST:
      return {
        ...state,
        getShiftManagLoading: true,
      };
    case employessTypes.GET_SHIFT_SUCCESS:
      return {
        ...state,
        getShiftManagLoading: false,
        getShiftManagInfo: payload,
        getShiftManagError: "",
      };
    case employessTypes.GET_SHIFT_FAIL:
      return {
        ...state,
        getShiftManagLoading: false,
        getShiftManagError: payload,
        getShiftManagInfo: {},
      };
    default:
      return state;
  }
};

export const empFilterReducers = (state = {}, action) => {
  const { type, payload } = action;

  switch (type) {
    case employessTypes.GET_EMP_FILTER_REQUEST:
      return {
        ...state,
        empFilterLoading: true,
      };
    case employessTypes.GET_EMP_FILTER_SUCCESS:
      return {
        ...state,
        empFilterLoading: false,
        empFilterData: payload,
        empFilterError: "",
      };
    case employessTypes.GET_EMP_FILTER_FAIL:
      return {
        ...state,
        empFilterLoading: false,
        empFilterError: payload,
        empFilterData: {},
      };
    default:
      return state;
  }
};

//download_shifts_reducer
export const downloadShiftsReducer = (state = {}, action) => {
  const { type, payload } = action;

  switch (type) {
    case employessTypes.DOWNLOAD_SHIFTS_REQUEST:
      return {
        ...state,
        downloadshiftsloading: true,
      };
    case employessTypes.DOWNLOAD_SHIFTS_SUCCESS:
      return {
        ...state,
        downloadshiftsloading: false,
        downloadshiftsdata: payload,
        downloadshiftserror: "",
      };
    case employessTypes.DOWNLOAD_SHIFTS_FAIL:
      return {
        ...state,
        downloadshiftsloading: false,
        downloadshiftserror: payload,
        downloadshiftsdata: null,
      };
    default:
      return state;
  }
};

//get_shift_manage_reducer
export const shiftManagementReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_SHIFT_MANAGEMENT_REQUEST:
      return {
        ...state,
        shiftManagLoading: true,
      };
    case employessTypes.GET_SHIFT_MANAGEMENT_SUCCESS:
      return {
        ...state,
        shiftManagLoading: false,
        shiftManagData: payload,
        shiftManagError: "",
      };
    case employessTypes.GET_SHIFT_MANAGEMENT_FAIL:
      return {
        ...state,
        shiftManagLoading: false,
        shiftManagError: payload,
        shiftManagData: {},
      };
    default:
      return state;
  }
};
export const addManyUserIdInShiftManageCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_MANY_USER_ID_IN_SHIFT_REQUEST:
      return {
        ...state,
        addManyUserIdInShiftLoading: true,
      };
    case employessTypes.ADD_MANY_USER_ID_IN_SHIFT_SUCCESS:
      return {
        ...state,
        addManyUserIdInShiftLoading: false,
        addManyUserIdInShiftInfo: payload,
        addManyUserIdInShiftError: "",
      };
    case employessTypes.ADD_MANY_USER_ID_IN_SHIFT_FAIL:
      return {
        ...state,
        addManyUserIdInShiftLoading: false,
        addManyUserIdInShiftError: payload,
        addManyUserIdInShiftInfo: {},
      };
    default:
      return state;
  }
};

export const updateManyStatusInShiftManageCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_STATUS_SHIFT_REQUEST:
      return {
        ...state,
        updateShiftStatusLoading: true,
      };
    case employessTypes.UPDATE_STATUS_SHIFT_SUCCESS:
      return {
        ...state,
        updateShiftStatusLoading: false,
        updateShiftStatusInfo: payload,
        updateShiftStatusError: "",
      };
    case employessTypes.UPDATE_STATUS_SHIFT_FAIL:
      return {
        ...state,
        updateShiftStatusLoading: false,
        updateShiftStatusError: payload,
        updateShiftStatusInfo: {},
      };
    default:
      return state;
  }
};

export const adminAddUserInDepartImportCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_ADD_USER_DEPARTMENT_IMPORT_REQUEST:
      return {
        ...state,
        addUserInDepartImportLoading: true,
      };
    case employessTypes.ADMIN_ADD_USER_DEPARTMENT_IMPORT_SUCCESS:
      return {
        ...state,
        addUserInDepartImportLoading: false,
        addUserInDepartImportInfo: payload,
        addUserInDepartImportError: "",
      };
    case employessTypes.ADMIN_ADD_USER_DEPARTMENT_IMPORT_FAIL:
      return {
        ...state,
        addUserInDepartImportLoading: false,
        addUserInDepartImportError: payload,
        addUserInDepartImportInfo: {},
      };
    default:
      return state;
  }
};

export const addBulkShiftReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_BULK_SHIFT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.ADD_BULK_SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.ADD_BULK_SHIFT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};

// GET WORK BREAK REDUCER
export const getWorkBreakCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_WORK_BREAK_REQUEST:
      return {
        ...state,
        getWorkBreakLoading: true,
      };
    case employessTypes.GET_WORK_BREAK_SUCCESS:
      return {
        ...state,
        getWorkBreakLoading: false,
        getWorkBreakInfo: payload,
        getWorkBreakError: "",
      };
    case employessTypes.GET_WORK_BREAK_FAIL:
      return {
        ...state,
        getWorkBreakLoading: false,
        getWorkBreakError: payload,
        getWorkBreakInfo: {},
      };
    default:
      return state;
  }
};

// REMOVE USER FROM SHIFT REDUCER
export const RemoveUserFromShiftCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_MANY_USER_ID_IN_SHIFT_REQUEST:
      return {
        ...state,
        RemoveUserFromShiftLoading: true,
      };
    case employessTypes.ADD_MANY_USER_ID_IN_SHIFT_SUCCESS:
      return {
        ...state,
        RemoveUserFromShiftLoading: false,
        RemoveUserFromShiftInfo: payload,
        RemoveUserFromShiftError: "",
      };
    case employessTypes.ADD_MANY_USER_ID_IN_SHIFT_FAIL:
      return {
        ...state,
        RemoveUserFromShiftLoading: false,
        RemoveUserFromShiftError: payload,
        RemoveUserFromShiftInfo: {},
      };
    default:
      return state;
  }
};

export const adminCheckUserInDepartImportCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_CHECK_USER_DEPARTMENT_IMPORT_REQUEST:
      return {
        ...state,
        checkUserInDepartImportLoading: true,
      };
    case employessTypes.ADMIN_CHECK_USER_DEPARTMENT_IMPORT_SUCCESS:
      return {
        ...state,
        checkUserInDepartImportLoading: false,
        checkUserInDepartImportInfo: payload,
        checkUserInDepartImportError: "",
      };
    case employessTypes.ADMIN_CHECK_USER_DEPARTMENT_IMPORT_FAIL:
      return {
        ...state,
        checkUserInDepartImportLoading: false,
        checkUserInDepartImportError: payload,
        checkUserInDepartImportInfo: {},
      };
    default:
      return state;
  }
};

export const adminAddUserLeaveDaysImportCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_ADD_USER_LEAVEDAYS_IMPORT_REQUEST:
      return {
        ...state,
        addUserLeaveDaysImportLoading: true,
      };
    case employessTypes.ADMIN_ADD_USER_LEAVEDAYS_IMPORT_SUCCESS:
      return {
        ...state,
        addUserLeaveDaysImportLoading: false,
        addUserLeaveDaysImportInfo: payload,
        addUserLeaveDaysImportError: "",
      };
    case employessTypes.ADMIN_ADD_USER_LEAVEDAYS_IMPORT_FAIL:
      return {
        ...state,
        addUserLeaveDaysImportLoading: false,
        addUserLeaveDaysImportError: payload,
        addUserLeaveDaysImportInfo: {},
      };
    default:
      return state;
  }
};

export const adminCheckUserLeaveDaysImportCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_REQUEST:
      return {
        ...state,
        checkUserLeaveDaysImportLoading: true,
      };
    case employessTypes.ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_SUCCESS:
      return {
        ...state,
        checkUserLeaveDaysImportLoading: false,
        checkUserLeaveDaysImportInfo: payload,
        checkUserLeaveDaysImportError: "",
      };
    case employessTypes.ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_FAIL:
      return {
        ...state,
        checkUserLeaveDaysImportLoading: false,
        checkUserLeaveDaysImportError: payload,
        checkUserLeaveDaysImportInfo: {},
      };
    default:
      return state;
  }
};

export const adminAddUserLeavesImportCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_ADD_USER_LEAVES_IMPORT_REQUEST:
      return {
        ...state,
        addUserLeavesImportLoading: true,
      };
    case employessTypes.ADMIN_ADD_USER_LEAVES_IMPORT_SUCCESS:
      return {
        ...state,
        addUserLeavesImportLoading: false,
        addUserLeavesImportInfo: payload,
        addUserLeavesImportError: "",
      };
    case employessTypes.ADMIN_ADD_USER_LEAVES_IMPORT_FAIL:
      return {
        ...state,
        addUserLeavesImportLoading: false,
        addUserLeavesImportError: payload,
        addUserLeavesImportInfo: {},
      };
    default:
      return state;
  }
};

export const adminCheckUserLeavesImportCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_CHECK_USER_LEAVES_IMPORT_REQUEST:
      return {
        ...state,
        checkUserLeavesImportLoading: true,
      };
    case employessTypes.ADMIN_CHECK_USER_LEAVES_IMPORT_SUCCESS:
      return {
        ...state,
        checkUserLeavesImportLoading: false,
        checkUserLeavesImportInfo: payload,
        checkUserLeavesImportError: "",
      };
    case employessTypes.ADMIN_CHECK_USER_LEAVES_IMPORT_FAIL:
      return {
        ...state,
        checkUserLeavesImportLoading: false,
        checkUserLeavesImportError: payload,
        checkUserLeavesImportInfo: {},
      };
    default:
      return state;
  }
};

export const adminAddUserCheckInOutImportCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_ADD_USER_CHECKINOUT_IMPORT_REQUEST:
      return {
        ...state,
        addUserCheckInOutImportLoading: true,
      };
    case employessTypes.ADMIN_ADD_USER_CHECKINOUT_IMPORT_SUCCESS:
      return {
        ...state,
        addUserCheckInOutImportLoading: false,
        addUserCheckInOutImportInfo: payload,
        addUserCheckInOutImportError: "",
      };
    case employessTypes.ADMIN_ADD_USER_CHECKINOUT_IMPORT_FAIL:
      return {
        ...state,
        addUserCheckInOutImportLoading: false,
        addUserCheckInOutImportError: payload,
        addUserCheckInOutImportInfo: {},
      };
    default:
      return state;
  }
};

export const adminUpdateBulkCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_UPDATE_BULK_EMPLOYEE_REQUEST:
      return {
        ...state,
        adminUpdateBulkCompanyLoading: true,
      };
    case employessTypes.ADMIN_UPDATE_BULK_EMPLOYEE_SUCCESS:
      return {
        ...state,
        adminUpdateBulkCompanyLoading: false,
        adminUpdateBulkCompanyInfo: payload,
        adminUpdateBulkCompanyError: "",
      };
    case employessTypes.ADMIN_UPDATE_BULK_EMPLOYEE_FAIL:
      return {
        ...state,
        adminUpdateBulkCompanyLoading: false,
        adminUpdateBulkCompanyError: payload,
        adminUpdateBulkCompanyInfo: {},
      };
    default:
      return state;
  }
};

export const adminCheckUserCheckInOutImportCompanyReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADMIN_CHECK_USER_CHECKINOUT_IMPORT_REQUEST:
      return {
        ...state,
        checkUserCheckInOutImportLoading: true,
      };
    case employessTypes.ADMIN_CHECK_USER_CHECKINOUT_IMPORT_SUCCESS:
      return {
        ...state,
        checkUserCheckInOutImportLoading: false,
        checkUserCheckInOutImportInfo: payload,
        checkUserCheckInOutImportError: "",
      };
    case employessTypes.ADMIN_CHECK_USER_CHECKINOUT_IMPORT_FAIL:
      return {
        ...state,
        checkUserCheckInOutImportLoading: false,
        checkUserCheckInOutImportError: payload,
        checkUserCheckInOutImportInfo: {},
      };
    default:
      return state;
  }
};

// ADD WORK BREAK REDUCER
export const addWorkBreakCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_WORK_BREAK_REQUEST:
      return {
        ...state,
        addWorkBreakLoading: true,
      };
    case employessTypes.ADD_WORK_BREAK_SUCCESS:
      return {
        ...state,
        addWorkBreakLoading: false,
        addWorkBreakInfo: payload,
        addWorkBreakError: "",
      };
    case employessTypes.ADD_WORK_BREAK_FAIL:
      return {
        ...state,
        addWorkBreakLoading: false,
        addWorkBreakError: payload,
        addWorkBreakInfo: {},
      };
    default:
      return state;
  }
};

// ADD USER IN WORK BREAK REDUCER
export const addUserInWorkBreakReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_USER_IN_WORK_BREAK_REQUEST:
      return {
        ...state,
        addUserInWorkBreakLoading: true,
      };
    case employessTypes.ADD_USER_IN_WORK_BREAK_SUCCESS:
      return {
        ...state,
        addUserInWorkBreakLoading: false,
        addUserInWorkBreakInfo: payload,
        addUserInWorkBreakError: "",
      };
    case employessTypes.ADD_USER_IN_WORK_BREAK_FAIL:
      return {
        ...state,
        addUserInWorkBreakLoading: false,
        addUserInWorkBreakError: payload,
        addUserInWorkBreakInfo: {},
      };
    default:
      return state;
  }
};

// REMOVE USER IN WORK BREAK REDUCER
export const removeUserInWorkBreakReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.REMOVE_USER_IN_WORK_BREAK_REQUEST:
      return {
        ...state,
        removeUserInWorkBreakLoading: true,
      };
    case employessTypes.REMOVE_USER_IN_WORK_BREAK_SUCCESS:
      return {
        ...state,
        removeUserInWorkBreakLoading: false,
        removeUserInWorkBreakInfo: payload,
        removeUserInWorkBreakError: "",
      };
    case employessTypes.REMOVE_USER_IN_WORK_BREAK_FAIL:
      return {
        ...state,
        removeUserInWorkBreakLoading: false,
        removeUserInWorkBreakError: payload,
        removeUserInWorkBreakInfo: {},
      };
    default:
      return state;
  }
};

// ADD EMPLOYEEE'S EMIRATES ID DOC REDUCER
export const addEmpEmiratesIdDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_EMIRATESID_DOC_REQUEST:
      return {
        ...state,
        empEmiratesIdDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_EMIRATESID_DOC_SUCCESS:
      return {
        ...state,
        empEmiratesIdDocLoading: false,
        empEmiratesIdDocInfo: payload,
        empEmiratesIdDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_EMIRATESID_DOC_FAIL:
      return {
        ...state,
        empEmiratesIdDocLoading: false,
        empEmiratesIdDocError: payload,
        empEmiratesIdDocInfo: {},
      };
    default:
      return state;
  }
};

// ADD EMPLOYEEE'S EMIRATES ID DOC REDUCER
export const addEmpAirReimburstDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_Air_REIMBURST_DOC_REQUEST:
      return {
        ...state,
        empAirReimburstLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_Air_REIMBURST_DOC_SUCCESS:
      return {
        ...state,
        empAirReimburstLoading: false,
        empAirReimburstInfo: payload,
        empAirReimburstError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_Air_REIMBURST_DOC_FAIL:
      return {
        ...state,
        empAirReimburstLoading: false,
        empAirReimburstError: payload,
        empAirReimburstInfo: {},
      };
    default:
      return state;
  }
};

// ADD EMPLOYEEE'S EDUCATION ID DOC REDUCER
export const addEmpEducationDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_EDUCATION_DOC_REQUEST:
      return {
        ...state,
        empEducationDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_EDUCATION_DOC_SUCCESS:
      return {
        ...state,
        empEducationDocLoading: false,
        empEducationDocInfo: payload,
        empEducationDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_EDUCATION_DOC_FAIL:
      return {
        ...state,
        empEducationDocLoading: false,
        empEducationDocError: payload,
        empEducationDocInfo: {},
      };
    default:
      return state;
  }
};

// ADD EMPLOYEEE'S LABOUR ID DOC REDUCER
export const addLabourDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_LABOUR_DOC_REQUEST:
      return {
        ...state,
        addLabourDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_LABOUR_DOC_SUCCESS:
      return {
        ...state,
        addLabourDocLoading: false,
        addLabourDocInfo: payload,
        addLabourDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_LABOUR_DOC_FAIL:
      return {
        ...state,
        addLabourDocLoading: false,
        addLabourDocError: payload,
        addLabourDocInfo: {},
      };
    default:
      return state;
  }
};

// ADD EMPLOYEEE'S INSURANCE ID DOC REDUCER
export const addEmpInsuranceDocReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_EMPLOYEES_INSURANCE_DOC_REQUEST:
      return {
        ...state,
        empInsuranceDocLoading: true,
      };
    case employessTypes.UPDATE_EMPLOYEES_INSURANCE_DOC_SUCCESS:
      return {
        ...state,
        empInsuranceDocLoading: false,
        empInsuranceDocInfo: payload,
        empInsuranceDocError: "",
      };
    case employessTypes.UPDATE_EMPLOYEES_INSURANCE_DOC_FAIL:
      return {
        ...state,
        empInsuranceDocLoading: false,
        empInsuranceDocError: payload,
        empInsuranceDocInfo: {},
      };
    default:
      return state;
  }
};

// ADD EMPLOYEEE'S CHECK IN REDUCER
export const addEmpCheckinReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_USER_CHECKIN_REQUEST:
      return {
        ...state,
        empCheckinLoading: true,
      };
    case employessTypes.ADD_USER_CHECKIN_SUCCESS:
      return {
        ...state,
        empCheckinLoading: false,
        empCheckinInfo: payload,
        empCheckinError: "",
      };
    case employessTypes.ADD_USER_CHECKIN_FAIL:
      return {
        ...state,
        empCheckinLoading: false,
        empCheckinError: payload,
        empCheckinInfo: {},
      };
    default:
      return state;
  }
};

// DELETE EMPLOYEEE'S CHECK IN REDUCER
export const deleteEmpCheckinReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.DELETE_USER_CHECKIN_REQUEST:
      return {
        ...state,
        empDeleteCheckinLoading: true,
      };
    case employessTypes.DELETE_USER_CHECKIN_SUCCESS:
      return {
        ...state,
        empDeleteCheckinLoading: false,
        empDeleteCheckinInfo: payload,
        empDeleteCheckinError: "",
      };
    case employessTypes.DELETE_USER_CHECKIN_FAIL:
      return {
        ...state,
        empDeleteCheckinLoading: false,
        empDeleteCheckinError: payload,
        empDeleteCheckinInfo: {},
      };
    default:
      return state;
  }
};

// GET HRM CHECKIN REDUCERS
export const getHrmCheckinReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_SEVEN_DAYS_USER_CHECKIN_REQUEST:
      return {
        ...state,
        getHrmCheckinLoading: true,
      };
    case employessTypes.GET_SEVEN_DAYS_USER_CHECKIN_SUCCESS:
      return {
        ...state,
        getHrmCheckinLoading: false,
        getHrmCheckinInfo: payload,
        getHrmCheckinError: "",
      };
    case employessTypes.GET_SEVEN_DAYS_USER_CHECKIN_FAIL:
      return {
        ...state,
        getHrmCheckinLoading: false,
        getHrmCheckinError: payload,
        getHrmCheckinInfo: {},
      };
    default:
      return state;
  }
};

// GET ALL DOCS REDUCERS
export const getAllDocsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_ALL_USER_DOCS_REQUEST:
      return {
        ...state,
        getAllDocsLoading: true,
      };
    case employessTypes.GET_ALL_USER_DOCS_SUCCESS:
      return {
        ...state,
        getAllDocsLoading: false,
        getAllDocsInfo: payload,
        getAllDocsError: "",
      };
    case employessTypes.GET_ALL_USER_DOCS_FAIL:
      return {
        ...state,
        getAllDocsLoading: false,
        getAllDocsError: payload,
        getAllDocsInfo: {},
      };
    default:
      return state;
  }
};

// CHECKIN REPORT REDUCER
export const employeeCheckinRangeReportReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_CHECKIN_RANGE_REPORT_REQUEST:
      return {
        ...state,
        employeeCheckinRangeReportLoading: true,
      };
    case employessTypes.EMPLOYEE_CHECKIN_RANGE_REPORT_SUCCESS:
      return {
        ...state,
        employeeCheckinRangeReportLoading: false,
        employeeCheckinRangeReportInfo: payload,
        employeeCheckinRangeReportError: "",
      };
    case employessTypes.EMPLOYEE_CHECKIN_RANGE_REPORT_FAIL:
      return {
        ...state,
        employeeCheckinRangeReportLoading: false,
        employeeCheckinRangeReportError: payload,
        employeeCheckinRangeReportInfo: {},
      };
    default:
      return state;
  }
};

// LateComing REPORT REDUCER
export const employeeLateComingRangeReportReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_LATE_COMING_RANGE_REPORT_REQUEST:
      return {
        ...state,
        employeeLateComingRangeReportLoading: true,
      };
    case employessTypes.EMPLOYEE_LATE_COMING_RANGE_REPORT_SUCCESS:
      return {
        ...state,
        employeeLateComingRangeReportLoading: false,
        employeeLateComingRangeReportInfo: payload,
        employeeLateComingRangeReportError: "",
      };
    case employessTypes.EMPLOYEE_LATE_COMING_RANGE_REPORT_FAIL:
      return {
        ...state,
        employeeLateComingRangeReportLoading: false,
        employeeLateComingRangeReportError: payload,
        employeeLateComingRangeReportInfo: {},
      };
    default:
      return state;
  }
};
export const salaryCSVReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_SALARY_CSV_REQUEST:
      return {
        ...state,
        loadingSalary: true,
      };
    case employessTypes.EMPLOYEE_SALARY_CSV_SUCCESS:
      return {
        ...state,
        loadingSalary: false,
        loadingList: payload,
        loadingErrors: "",
      };
    case employessTypes.EMPLOYEE_SALARY_CSV_FAIL:
      return {
        ...state,
        loadingSalary: false,
        loadingErrors: payload,
        loadingList: [],
      };
    default:
      return state;
  }
};

export const editEmployeeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EDIT_EMPLOYEE_REQUEST:
      return {
        ...state,
        EditEmployeeLoading: true,
      };
    case employessTypes.EDIT_EMPLOYEE_SUCCESS:
      return {
        ...state,
        EditEmployeeLoading: false,
        EditEmployeeList: payload,
        EditEmployeeErrors: "",
      };
    case employessTypes.EDIT_EMPLOYEE_FAIL:
      return {
        ...state,
        EditEmployeeLoading: false,
        EditEmployeeErrors: payload,
        EditEmployeeList: [],
      };
    default:
      return state;
  }
};
export const addNewEmployeeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.ADD_NEW_EMPLOYEE_REQUEST:
      return {
        ...state,
        EmployeeLoading: true,
      };
    case employessTypes.ADD_NEW_EMPLOYEE_SUCCESS:
      return {
        ...state,
        EmployeeLoading: false,
        EmployeeList: payload,
        EmployeeErrors: "",
      };
    case employessTypes.ADD_NEW_EMPLOYEE_FAIL:
      return {
        ...state,
        EmployeeLoading: false,
        EmployeeErrors: payload,
        EmployeeList: [],
      };
    default:
      return state;
  }
};

export const uploadUserDocumentFileReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPLOAD_USER_DOCUMENT_FILE_REQUEST:
      return {
        ...state,
        EmployeeLoading: true,
      };
    case employessTypes.UPLOAD_USER_DOCUMENT_FILE_SUCCESS:
      return {
        ...state,
        EmployeeLoading: false,
        EmployeeList: payload,
        EmployeeErrors: "",
      };
    case employessTypes.UPLOAD_USER_DOCUMENT_FILE_FAIL:
      return {
        ...state,
        EmployeeLoading: false,
        EmployeeErrors: payload,
        EmployeeList: [],
      };
    default:
      return state;
  }
};

export const createUserDocumentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.CREATE_USER_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.CREATE_USER_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        EmployeeList: payload,
        EmployeeErrors: "",
      };
    case employessTypes.CREATE_USER_DOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        EmployeeErrors: payload,
        EmployeeList: [],
      };
    default:
      return state;
  }
};

export const updateUserDocumentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_USER_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.UPDATE_USER_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        EmployeeList: payload,
        EmployeeErrors: "",
      };
    case employessTypes.UPDATE_USER_DOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        EmployeeErrors: payload,
        EmployeeList: [],
      };
    default:
      return state;
  }
};
export const updateChangeUserDocumentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.UPDATE_CHANGE_USER_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.UPDATE_CHANGE_USER_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        EmployeeList: payload,
        EmployeeErrors: "",
      };
    case employessTypes.UPDATE_CHANGE_USER_DOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        EmployeeErrors: payload,
        EmployeeList: [],
      };
    default:
      return state;
  }
};

export const getAllUserDynamicDocumentsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_ALL_USER_DYNAMIC_DOCUMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.GET_ALL_USER_DYNAMIC_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        userDynamicDocumentsList: payload,
        error: "",
      };
    case employessTypes.GET_ALL_USER_DYNAMIC_DOCUMENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        userDynamicDocumentsList: [],
      };
    default:
      return state;
  }
};

export const getCompanyHierarchyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_COMPANY_HIERARCHY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.GET_COMPANY_HIERARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.GET_COMPANY_HIERARCHY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const getDepartmentHierarchyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_DEPARTMENT_HIERARCHY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.GET_DEPARTMENT_HIERARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.GET_DEPARTMENT_HIERARCHY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const changeCompanyHierarchyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.CHANGE_COMPANY_HIERARCHY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.CHANGE_COMPANY_HIERARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.CHANGE_COMPANY_HIERARCHY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const employeeLeaveAddStepperReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case employessTypes.EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const getLeaveByUserReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case employessTypes.GET_LEAVE_BY_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case employessTypes.GET_LEAVE_BY_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        leaves: payload,
        error: "",
      };
    case employessTypes.GET_LEAVE_BY_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        leaves: [],
      };
    default:
      return state;
  }
};